import { generateHash } from 'random-hash';

export function generateSplitLine() {
  return { amount: 0, key: generateHash() };
}
